import React, {useState, useEffect} from 'react';
import { Input } from './FormControls';
import AddressInputs from './AddressInputs';
import tw from 'twin.macro';

const AddressFormField = ({ data, value, id, dispatch }) => {
    const [addressComponents, setAddressComponents] = useState(null)
    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    let autocomplete

    const fillInAddress = () => {
        const place = autocomplete.getPlace()
        let addressComponents = {}

        place.address_components.map(component => {
            switch (component.types[0]) {
                case 'street_number':
                    addressComponents.address = {id: '1', value: component.long_name}
                    break;
                case 'route':
                    addressComponents.address.value += ` ${component.long_name}`
                    break;
                case 'locality':
                    addressComponents.city = {id: '3', value: component.long_name}
                    break;
                case 'administrative_area_level_1':
                    addressComponents.state = {id: '4', value: component.long_name}
                    break;
                case 'country':
                    addressComponents.country = {id: '5', value: component.long_name}
                    break;
                case 'postal_code':
                    addressComponents.zip_code = {id: '6', value: component.long_name }
                    break;
                default:
                    break;
            }
        })

        setAddressComponents(addressComponents)
    }

    if (typeof window !== 'undefined') {
        window.initAutocomplete = () => {
            autocomplete = new window.google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ["geocode"] })
            autocomplete.setFields(["address_component"])
            autocomplete.addListener("place_changed", fillInAddress)
            setLoading(false)
        }
    }

    const handleChange = e => {
        dispatch({ type: 'updateField', key: 'e.target.id', value: e.target.value })
    }
    
    useEffect(() => {
        for (const component in addressComponents) {
            let addressComponent = addressComponents[component]
            dispatch({
                type: 'updateField',
                key: `input_${id}_${addressComponent.id}`,
                value: addressComponent.value
            })
        }
    }, [addressComponents])

    return (
        <>
            <Input 
                id="autocomplete"
                css={[
                    ((error !== null) && tw`h-0`)
                ]}
                placeholder="Type to search..." 
                autocomplete="off" 
            /> 

            {(error !== null) && (
                <AddressInputs data={data} id={id} dispatch={dispatch} />
            )}
        </>
    )
}

export default AddressFormField;